































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

interface ImageLibraryItem {
  id: number;
  imageName: string;
  imageUrl: string;
}

@Component
export default class ImageLibraryDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly visible!: boolean;

  @Prop({ type: String, default: '选择图片' })
  readonly title!: string;

  @Prop({ type: Array, default: () => [] })
  readonly imageList!: ImageLibraryItem[];

  @Prop({ type: String, default: '' })
  readonly value!: string;

  dialogVisible = false;
  selectedValue = '';

  @Watch('visible', { immediate: true })
  onVisibleChange(val: boolean) {
    this.dialogVisible = val;
    if (val) {
      this.selectedValue = this.value || '';
    }
  }

  @Watch('value')
  onValueChange(val: string) {
    if (this.dialogVisible) {
      this.selectedValue = val || '';
    }
  }

  handleCancel() {
    this.dialogVisible = false;
    this.selectedValue = this.value || '';
    this.$emit('update:visible', false);
    this.$emit('cancel');
  }

  handleConfirm() {
    this.$emit('confirm', this.selectedValue);
    this.dialogVisible = false;
    this.$emit('update:visible', false);
  }
}
